export const REMAIN_ANNUAL_LEAVE_BY_FINANCIAL_AND_EMPLOYEE = "REMAIN_ANNUAL_LEAVE_BY_FINANCIAL_AND_EMPLOYEE";
export const GET_DIVISION_LIST = "GET_DIVISION_LIST";
export const GET_DEPARTMENT_BY_DIVISION_LIST = "GET_DEPARTMENT_BY_DIVISION_LIST";
export const GET_ROLE_LIST = "GET_ROLE_LIST";
export const GET_EMPLOYEE_LIST = "GET_EMPLOYEE_LIST";
export const GET_EMPLOYEE_BY_PROJECT_LIST = "GET_EMPLOYEE_BY_PROJECT_LIST";
export const GET_PROJECT_LIST = "GET_PROJECT_LIST";
export const GET_PROJECT_BY_EMPLOYEE_LIST = "GET_PROJECT_BY_EMPLOYEE_LIST";
export const GET_BALANCE_EMPLOYEE = "GET_BALANCE_EMPLOYEE";
export const GET_PROJECT_REDIS_LIST = "GET_PROJECT_REDIS_LIST";
export const GET_PROJECT_REDIS_LIST_BY_PAGINATION = "GET_PROJECT_REDIS_LIST_BY_PAGINATION";
export const SET_PAGE_SELECT = "SET_PAGE_SELECT";
export const GET_WORK_SCHEDULE_CODE_LIST = "GET_WORK_SCHEDULE_CODE_LIST";
export const GET_WORK_SCHEDULE_TYPE_LIST = "GET_WORK_SCHEDULE_TYPE_LIST";
export const GET_RULE_WORK_SCHEDULE_CONFIG_LIST = "GET_RULE_WORK_SCHEDULE_CONFIG_LIST";
